import PermissionService from './PermissionService';

class PhrmService {
  static async isPhrmEnabled() {
    try {
      const permissions = await PermissionService.getUserPermissions();
      console.log('PHRM Debug - All permissions:', permissions);
      console.log('PHRM Debug - PHRM value:', permissions?.phrm);
      console.log('PHRM Debug - Is enabled:', permissions?.phrm === true);
      
      return permissions?.phrm === true;
    } catch (error) {
      console.error('Error checking PHRM permissions:', error);
      return false;
    }
  }

  static getFieldLabels(isPhrmEnabled) {
    if (isPhrmEnabled) {
      return {
        title: 'Goal Title*',
        target: 'Goal KPI Actual Amount*',
        targetDate: 'Target Date*',
        description: 'Goal Description',
      };
    } else {
      return {
        title: 'Title*',
        target: 'Target*',
        targetDate: 'Target Date*', 
        description: 'Description',
      };
    }
  }

  static shouldShowEhrmFields(isPhrmEnabled) {
    return isPhrmEnabled;
  }

  static shouldShowEmpReference(isPhrmEnabled) {
    return isPhrmEnabled;
  }
}

export default PhrmService;
